import { render, staticRenderFns } from "./FormPFHT.vue?vue&type=template&id=0fad8645&scoped=true"
import script from "./FormPFHT.vue?vue&type=script&lang=js"
export * from "./FormPFHT.vue?vue&type=script&lang=js"
import style0 from "./FormPFHT.vue?vue&type=style&index=0&id=0fad8645&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad8645",
  null
  
)

export default component.exports